import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IBooking } from 'app/shared/model/booking.model';
import { getEntities as getBookings } from 'app/entities/booking/booking.reducer';
import { IBookingPax } from 'app/shared/model/booking-pax.model';
import { getEntity, updateEntity, createEntity, reset } from './booking-pax.reducer';

export const BookingPaxUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const bookings = useAppSelector(state => state.booking.entities);
  const bookingPaxEntity = useAppSelector(state => state.bookingPax.entity);
  const loading = useAppSelector(state => state.bookingPax.loading);
  const updating = useAppSelector(state => state.bookingPax.updating);
  const updateSuccess = useAppSelector(state => state.bookingPax.updateSuccess);

  const handleClose = () => {
    navigate('/booking-pax' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getBookings({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...bookingPaxEntity,
      ...values,
      booking: bookings.find(it => it.id.toString() === values.booking.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bookingPaxEntity,
          booking: bookingPaxEntity?.booking?.id,
        };

  console.log(' -------------------------------- > ' + bookings);
  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.bookingPax.home.createOrEditLabel" data-cy="BookingPaxCreateUpdateHeading">
            <Translate contentKey="activitiesApp.bookingPax.home.createOrEditLabel">Create or edit a BookingPax</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="booking-pax-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.bookingPax.title')}
                id="booking-pax-title"
                name="title"
                data-cy="title"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingPax.firsName')}
                id="booking-pax-firsName"
                name="firsName"
                data-cy="firsName"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingPax.lastName')}
                id="booking-pax-lastName"
                name="lastName"
                data-cy="lastName"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingPax.email')}
                id="booking-pax-email"
                name="email"
                data-cy="email"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingPax.mobileNumber')}
                id="booking-pax-mobileNumber"
                name="mobileNumber"
                data-cy="mobileNumber"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingPax.sprcialRequirements')}
                id="booking-pax-sprcialRequirements"
                name="sprcialRequirements"
                data-cy="sprcialRequirements"
                type="text"
              />
              <ValidatedField
                id="booking-pax-booking"
                name="booking"
                data-cy="booking"
                label={translate('activitiesApp.bookingPax.booking')}
                type="select"
              >
                <option value="" key="0" />
                {bookings
                  ? bookings.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>{' '}
              */
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/booking-pax" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BookingPaxUpdate;
